import React from "react";
import { View, ViewProps, StyleSheet } from "react-native";
import { ThemeOptions, useTheme } from "../providers/ThemeProvider";

const makeStyles = (theme: ThemeOptions) => {
  return StyleSheet.create({
    column: {
      flexGrow: 1,
      borderRadius: theme.borderRadius.large,
      backgroundColor: theme.toRgba(theme.contrastColor, 0.2),
      shadowColor: theme.colors.grey2,
      shadowOffset: { width: theme.scaled(-2), height: theme.scaled(4) },
      shadowOpacity: 0.2,
      shadowRadius: 3,
      borderWidth: theme.borderWidth.regular,
      borderColor: theme.toRgba(theme.contrastColor, 0.2),
      overflow: "hidden",
    },
    columnSecondary: {
      backgroundColor: theme.toRgba(theme.contrastColor, 0.1),
    },
  });
};

export const BorderedContainer = ({
  style,
  variant,
  ...props
}: ViewProps & { variant?: "default" | "secondary" }) => {
  const theme = useTheme();
  const styles = makeStyles(theme);
  return (
    <View
      style={[
        styles.column,
        variant === "secondary" ? styles.columnSecondary : undefined,
        style,
      ]}
      {...props}
    />
  );
};
